import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user views the onboarding invite members step',
  name: 'viewed_onboarding_invite_members',
};

export default META;
